@if (showAppNavbar()) {
  <lib-navbar
    [navClass]="'absolute bg-transparent z-10'"
    [showNotification]="false" />
}

<div class="relative">
  <lib-maintenance-mode />
  <lib-site-redirect-notice />

  <main
    [class]="
      showAppNavbar()
        ? 'w-full overflow-y-auto relative z-0'
        : 'w-full relative z-0'
    ">
    <router-outlet />
  </main>

  @if (showToast()) {
    <lib-alert-inline
      [alertData]="toastData().alertData"
      [hasCloseIcon]="toastData().hasCloseIcon"
      [hasIcon]="toastData().hasIcon"
      (handleAlertClose)="onCloseToast($event)"
      class="absolute top-10 end-5" />
  }
</div>
